import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { MessageBox, MessageBoxProps } from '../MessageBox/MessageBox';
import styles from './MessageListBox.module.css';
export type MessageListBoxProps = MessageBoxProps;
export const MessageListBox: FunctionComponent<MessageListBoxProps> = React.memo(props => {
  const $ = _c(10);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let children;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      children,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = children;
    $[4] = remainingProps;
  } else {
    children = $[3];
    remainingProps = $[4];
  }
  let t1;
  if ($[5] !== children) {
    t1 = <ul className={styles.list}>{children}</ul>;
    $[5] = children;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== remainingProps || $[8] !== t1) {
    t2 = <MessageBox {...remainingProps}>{t1}</MessageBox>;
    $[7] = remainingProps;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
});